/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountValidationOutcomeFilter {
    COMPLIANT = 'COMPLIANT',
    FAILED = 'FAILED',
    INCONCLUSIVE = 'INCONCLUSIVE',
    NOT_CHECKED = 'NOT_CHECKED',
}
